// src/toastMessages.js
import * as React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const productAddedToCartSuccess = (props) => {
    toast.success(
        <div className="success-toast"><i className="fas fa-check-circle mr-2" style={{ fontSize:"20px" }}></i>Product Added To <strong>{props.cartName}</strong></div>
    );
};

const productAddedToCartError = () => {
    toast.error(
        <div className="error-toast"><i className="fas fa-times-circle mr-2" style={{ fontSize: "20px" }}></i>An error occurred while adding the item to your cart. Please try again later.</div>
    );
};

const productGetQuantityError = () => {
    toast.error(
        <div className="error-toast"><i className="fas fa-times-circle mr-2" style={{ fontSize: "20px" }}></i>An error occurred while getting the item quantity. Please try again later.</div>
    );
};

const createCartSuccess = (props) => {
    toast.success(
        <div className="success-toast"><i className="fas fa-check-circle mr-2" style={{ fontSize: "20px" }}></i><strong>{props.cartName}</strong> created.</div>
    );
};

const deleteCartSuccess = (props) => {
    toast.success(
        <div className="success-toast"><i className="fas fa-check-circle mr-2" style={{ fontSize: "20px" }}></i><strong>{props.cartName}</strong> deleted.</div>
    );
};

const cartIdCopiedToClipboardSuccess = (props) => {
    toast.success(
        <div className="success-toast"><i className="fas fa-check-circle mr-2" style={{ fontSize: "20px" }}></i><strong>{props.cartName}</strong> ID copied to clipboard.</div>
    );
};

const sendCartOrderSuccess = (props) => {
    toast.success(
        <div className="success-toast"><i className="fas fa-check-circle mr-2" style={{ fontSize: "20px" }}></i><strong>{props.cartName}</strong> Cart order has been successfully submitted.</div>
    );
};

export const Toasts = {
    productAddedToCartSuccess,
    productAddedToCartError,
    productGetQuantityError,
    createCartSuccess,
    deleteCartSuccess,
    cartIdCopiedToClipboardSuccess,
    sendCartOrderSuccess
}